import React from 'react'
import "./Daily_Task_btn.css"
import Collect_Every_24_Hours_modal from '../common_modal/collect_Every_24_Hours_modal/Collect_Every_24_Hours_modal';
import Earn_coins_animation from '../../animations/earn_coins_animation/Earn_coins_animation';
import animationData from "../../animations/earn_coins_animation/Earn_coins_animation.json"
import animationCollectCoinsData from "../../animations/collect_Earn_coins_animation/Collect_Earn_coins_animation.json"
import Collect_Earn_coins_animation from '../../animations/collect_Earn_coins_animation/Collect_Earn_coins_animation';

function Daily_Task_btn() {
  const [modalHoursShow, setModalHoursShow] = React.useState(false);

  return (
    <>
      <section className='Daily_Task_btn_holder'>
        <div className='Daily_Task_btn' onClick={() => setModalHoursShow(true)}>
          <div className="text_holder">
            <p>Daily Task</p>
          </div>

          <div className="coint_image_holder">
            <Earn_coins_animation animationData={animationData} />

          </div>
        </div>
        <Collect_Earn_coins_animation animationCollectCoinsData={animationCollectCoinsData} />
      </section>


      <Collect_Every_24_Hours_modal
        show={modalHoursShow}
        onHide={() => setModalHoursShow(false)}
      />

    </>
  )
}

export default Daily_Task_btn